export default "__VITE_ASSET__BmU1m8MF__"